module.exports = __webpack_public_path__ + "static/img/logo.7cf91390.png";